import React from 'react'
import { notification } from 'antd'
import moment from 'moment'

import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'
import { Column } from 'primereact/column'
import { isRtv } from '../../util/profiles'
import { isOpenStatus } from '../../util/walletStatus'

export function updateCustomersApprovalStatus(memberId, status) {
  return request(
    api.updateMember(memberId, {
      customersApproved: status,
      onlyUpdateMember: true
    })
  )
}

export async function retrieveConfiguration(organizationId) {
  const data = await request(api.findParametersByKey('wallet-configuration'), true)
  const periodFiltered = data.parameterValue.periods.find(
    (period) => period.organizationId === parseInt(organizationId)
  )
  const period = periodFiltered || data.parameterValue.periods[0]

  return {
    ...period,
    clientEditionPeriodStartDate: new moment(period.clientEditionPeriodStartDate),
    clientEditionPeriodEndDate: new moment(period.clientEditionPeriodEndDate)
  }
}

export function validateCanEditWalletByRange(startDate, endDate, showWarning = true) {
  if (!startDate || !endDate) {
    return false
  }

  const isBetween =
    moment().startOf('day').diff(startDate.startOf('day')) >= 0 &&
    moment().startOf('day').diff(endDate.startOf('day')) <= 0

  if (!isBetween) {
    if (showWarning) {
      notification.warning({
        description: getMessage('editWalletRangeClosedError'),
        message: getMessage('notification.warning')
      })
    }

    return false
  }

  return true
}

export function validateCanEditWalletByProfileId(profileId, showWarning = true) {
  const profilesCanEdit = [1, 2, 4, 5]
  if (!profilesCanEdit.includes(parseInt(profileId))) {
    if (showWarning) {
      notification.warning({
        description: getMessage('editWalletProfileIdError'),
        message: getMessage('notification.warning')
      })
    }

    return false
  }

  return true
}

export function hasEditAccess(walletStatusId, loggedUser) {
  return walletStatusId && (isOpenStatus(walletStatusId) || !isRtv(loggedUser))
}

export const columnsCustomerAvailableList = [
  <Column key="selection" selectionMode="multiple" headerStyle={{ width: '3em' }} style={{ maxWidth: '15px' }} />,
  <Column
    key="customer"
    field="customerName"
    header={getMessage('customer')}
    filterField="customerName"
    filter
    filterMatchMode="contains"
    filterPlaceholder={getMessage('search')}
    responsive={true}
  />,
  <Column
    key="location"
    field="location"
    header={getMessage('location')}
    filterField="location"
    filter
    filterMatchMode="contains"
    filterPlaceholder={getMessage('search')}
    responsive={true}
  />,
  <Column
    key="areaTotal"
    field="areaTotal"
    header={getMessage('areaTotal')}
    filterField="areaTotal"
    filter
    filterMatchMode="contains"
    filterPlaceholder={getMessage('search')}
    responsive={true}
    body={({ areaTotal }) => {
      const formattedValue = areaTotal != null ? parseFloat(areaTotal).toLocaleString('pt-BR') + ' ha' : '0 ha'
      return <p style={{ textAlign: 'center', margin: 0 }}>{formattedValue}</p>
    }}
  />
]
